import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import individualReadAction from './individualRead.action.json'

const individualReadDefinition = defineReadAutoAction(individualReadAction, 'individual')

export default individualReadDefinition
